"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listPropertyReducer = void 0;
var ListPropertyAction_1 = require("@/pages/listProperty/actions/ListPropertyAction");
var ListPropertyState_init_1 = require("@/pages/listProperty/states/ListPropertyState.init");
var typesafe_actions_1 = require("typesafe-actions");
exports.listPropertyReducer = function (state, action) {
    if (state === void 0) { state = ListPropertyState_init_1.defaultListPropertyState; }
    switch (action.type) {
        case typesafe_actions_1.getType(ListPropertyAction_1.default.showPopup): {
            return __assign(__assign({}, state), { popupActive: true });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.hidePopup): {
            return __assign(__assign({}, state), { popupActive: false });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.setPopupIndex): {
            return __assign(__assign({}, state), { popupIndex: action.payload });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.setCompareView): {
            return __assign(__assign({}, state), { compare: action.payload });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.setExposureActive): {
            return __assign(__assign({}, state), { exposureActive: action.payload });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.setListingType): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { listingType: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.setSaleAvailability): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { saleAvailableType: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.setRentAvailability): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { rentAvailableType: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onBuildingNameChange): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { buildingName: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onPriceChange): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { priceHkd: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onRentAvailableDateChanged): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { rentAvailbleDate: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onSizeChanged): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { size: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onBedChanged): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { beds: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onBathChanged): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { baths: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onFeatureToggle): {
            var clickedFeature = action.payload;
            var existingFeatureIndex = state.form.features.indexOf(clickedFeature);
            var newFeatures = existingFeatureIndex >= 0 ? __spreadArrays(state.form.features.slice(0, existingFeatureIndex), state.form.features.slice(existingFeatureIndex + 1)) : __spreadArrays(state.form.features, [action.payload]);
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { features: newFeatures }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onCommentChanged): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { comments: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onClientEmailChanged): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { clientEmail: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onClientNameChanged): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { clientName: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onClientPhoneChanged): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { clientPhone: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onClientSubscribed): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { clientSubscribed: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onClientConsent): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { clientConsent: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.onClientTerms): {
            return __assign(__assign({}, state), { form: __assign(__assign({}, state.form), { clientTerms: action.payload }) });
        }
        case typesafe_actions_1.getType(ListPropertyAction_1.default.setSubmitting): {
            return __assign(__assign({}, state), { isFormSubmiting: action.payload });
        }
    }
    return state;
};
